document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".so-header");
  if (!header) return;

  const sentinel = document.createElement("div");
  sentinel.className = "so-header-sentinel";
  header.parentNode.insertBefore(sentinel, header);

  const headerHeight = header.offsetHeight || 96;

  const io = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        header.classList.remove("is-fixed");
        document.documentElement.style.removeProperty("--so-fixed-pad");
      } else {
        header.classList.add("is-fixed");
        document.documentElement.style.setProperty("--so-fixed-pad", headerHeight + "px");
      }
    },
    { threshold: 0 }
  );

  io.observe(sentinel);
});
